// types
import { ILocation } from './types'

// components
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { BsPinMap } from 'react-icons/bs';
import { useStyletron } from 'baseui';
import { GoogleMap } from '../../../components/Map';
import { TMarker } from '../../../components/Map/Map';

export function OverviewPanel(props: ILocation) {
    const [,theme] = useStyletron();
    
    const markers: TMarker[] = [{ latitude: props.latitude, longitude: props.longitude, title: props.description }];
    return (
        <OverviewPanelWrapper small icon={<BsPinMap size='100%' color={theme.colors.backgroundPrimary}></BsPinMap>} {...props}>
            <GoogleMap markers={markers}   ></GoogleMap>
        </OverviewPanelWrapper>
    );
}

//name={props.description}